var baseIsEqual=require("./_baseIsEqual");function isEqual(a,s){return baseIsEqual(a,s)}module.exports=isEqual;